import { RequestDetailsForApprovalResponse, sendFollowUp } from "@api";
import { Modal } from "@components";
import { Button, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

interface Props {
  detail: RequestDetailsForApprovalResponse;
  onViewHistory: () => void;
  onSendBack: () => void;
  onReject: () => void;
  onCancel: () => void;
  onApproveRequest: () => void;
  onViewAttestation: () => void;
  onViewProvisioners: () => void;
  onReassign: () => void;
  isRejecting: boolean;
}
//
interface ButtonsDetail {
  show: boolean | null;
  label: string;
  content: React.ReactNode | null;
}

export const Buttons: React.FC<Props> = ({
  detail,
  onViewHistory,
  onSendBack,
  onReject,
  onApproveRequest,
  onViewAttestation,
  onCancel,
  onViewProvisioners,
  onReassign,
  isRejecting,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const location = useLocation<{ readonlyAttestation?: boolean }>();
  let buttonViewHistory: ButtonsDetail = {
    show: true,
    label: "View History",
    content: undefined,
  };
  let buttonSendBackRequestor: ButtonsDetail = {
    show: detail.viewRole === "Approver",
    label: "Send Back To Requestor",
    content: undefined,
  };
  //
  let buttonRejectRequest: ButtonsDetail = {
    show:
      detail.viewRole === "UAM" &&
      detail.request.status === "APPROVAL IN-PROGRESS",
    label: "Reject Request",
    content: undefined,
  };
  let buttonApproveRequest: ButtonsDetail = {
    show: false,
    label: "Approve Request",
    content: undefined,
  };

  let buttonViewAttestation: ButtonsDetail = {
    show: detail.request.isAttestationNeeded,
    label:
      location.state?.readonlyAttestation || detail.request.isAttestationSigned
        ? "View Attestation"
        : "Sign Attestation",
    content: undefined,
  };
  let buttonSendFollowUp: ButtonsDetail = {
    show:
      detail.viewRole === "Requestor" &&
      detail.request.status === "APPROVAL IN-PROGRESS" &&
      !detail.request.isSendBack,
    label: "Send Follow Up",
    content: undefined,
  };
  let buttonReSubmitRequest: ButtonsDetail = {
    show:
      detail.viewRole === "Requestor" &&
      detail.request.status === "APPROVAL IN-PROGRESS" &&
      detail.request.isSendBack,
    label: "Re-Submit Request",
    content: undefined,
  };
  let buttonCancelRequest: ButtonsDetail = {
    show:
      detail.viewRole === "Requestor" &&
      detail.request.status === "APPROVAL IN-PROGRESS",
    label: "Cancel Request",
    content: undefined,
  };

  if (buttonViewHistory.show) {
    buttonViewHistory.content = (
      <Button variant="outlined" color="primary" onClick={onViewHistory}>
        {buttonViewHistory.label}
      </Button>
    );
  }

  if (buttonSendBackRequestor.show) {
    buttonSendBackRequestor.content = (
      <Button
        variant="outlined"
        color="primary"
        disableElevation
        onClick={onSendBack}
      >
        {buttonSendBackRequestor.label}
      </Button>
    );
  }

  if (buttonRejectRequest.show) {
    buttonRejectRequest.content = (
      <Button
        variant="contained"
        color="secondary"
        disabled={isRejecting}
        disableElevation
        onClick={onReject}
      >
        {buttonRejectRequest.label}
      </Button>
    );
  }

  if (buttonApproveRequest.show) {
    buttonApproveRequest.content = (
      <Button
        variant="contained"
        color="primary"
        disableElevation
        onClick={onApproveRequest}
      >
        {buttonApproveRequest.label}
      </Button>
    );
  }

  if (buttonViewAttestation.show) {
    buttonViewAttestation.content = (
      <Button variant="outlined" color="primary" onClick={onViewAttestation}>
        {buttonViewAttestation.label}
      </Button>
    );
  }

  if (buttonSendFollowUp.show) {
    buttonSendFollowUp.content = (
      <Button
        variant="outlined"
        color="primary"
        onClick={() =>
          sendFollowUp(detail.request.id).then(() => setOpen(true))
        }
      >
        {buttonSendFollowUp.label}
      </Button>
    );
  }

  if (buttonReSubmitRequest.show) {
    buttonReSubmitRequest.content = (
      <Button variant="outlined" color="primary" onClick={onViewHistory}>
        {buttonReSubmitRequest.label}
      </Button>
    );
  }
  if (buttonCancelRequest.show) {
    buttonCancelRequest.content = (
      <Button variant="outlined" color="primary" onClick={onCancel}>
        {buttonCancelRequest.label}
      </Button>
    );
  }

  return (
    <Grid container justify="flex-end" direction="row" spacing={2}>
      <Grid item>{buttonViewHistory.content}</Grid>
      <Grid item>{buttonRejectRequest.content}</Grid>
      <Grid item>{buttonViewAttestation.content}</Grid>
      <Grid item>{buttonCancelRequest.content}</Grid>
      <Grid item>{buttonApproveRequest.content}</Grid>
      {/* <Grid item>
        <Button variant="outlined" color="primary" onClick={onViewProvisioners}>
          View Provisioners
        </Button>
      </Grid> */}
      {/* <Grid item>
        <Button variant="outlined" color="primary" onClick={onReassign}>
          Re-Assign Request
        </Button>
      </Grid> */}

      <Modal
        title="Follow up"
        isOpen={open}
        closeModal={() => setOpen(false)}
        actions={[
          {
            label: "Dismiss",
            handler: () => {
              setOpen(false);
            },
          },
        ]}
      >
        <Typography align="center" paragraph>
         Follow up was sent successfully
        </Typography>
      </Modal>
    </Grid>
  );
};
